import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import utc from 'dayjs/plugin/utc';
import tz from 'dayjs/plugin/timezone';

export function formatDate(
  date: string,
  format?: string,
  timezone?: string
): string {
  if (timezone) {
    dayjs.extend(utc);
    dayjs.extend(tz);
    return dayjs(date)
      .tz(timezone)
      .format(format || 'dddd, D MMMM');
  }

  return dayjs(date).format(format || 'dddd, D MMMM');
}

export function getTimezoneOffsetName(
  date: string,
  timezone: string
): string | undefined {
  dayjs.extend(utc);
  dayjs.extend(tz);
  return dayjs(date).tz(timezone).offsetName();
}

const localeMap: {[key: string]: string} = {
  en: 'en-gb',
  es: 'es',
  fr: 'fr',
  de: 'de',
  nl: 'nl',
  it: 'it',
  lt: 'lt',
  pt: 'pt',
  el: 'el',
};

export async function fetchLocale(locale: string): Promise<void> {
  const daysjsLocale = localeMap[locale.split('_')[0].toLowerCase()];

  try {
    await import(
      /* webpackChunkName: "dayjs-locales-[request]" */ `dayjs/locale/${daysjsLocale}.js`
    );
    dayjs.locale(daysjsLocale);
  } catch (e) {
    dayjs.locale('en-gb');
  }
}

function getHourText(
  hours: number,
  cms: {hour: string; hours: string}
): string {
  if (hours === 1) {
    return `${hours} ${cms.hour}`;
  } else if (hours > 1) {
    return `${hours} ${cms.hours}`;
  }
  return '';
}

export function formatDuration(
  minutes: number,
  cms: {hour: string; hours: string; minutes: string}
): string {
  const hours = Math.floor(minutes / 60);
  const hourText = getHourText(hours, cms);
  const mins = minutes % 60;
  const minutesAndText = mins > 0 ? `${mins} ${cms.minutes}` : '';

  return `${hourText} ${minutesAndText}`.trim();
}
